// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"46":"03e58c8c","239":"8b59c4a0","318":"216335b4","405":"18a7fcbf","744":"7e27f4dd","760":"95596180","850":"68b8fdfe","913":"237c8089"}[chunkId] + ".chunk.js";
};